export default __webpack_public_path__ + "static/media/logo.0208e6cb.png";